'use client';

import NextError from 'next/error';
import React, { useEffect } from 'react';
import { handleException } from '@/src/lib/core/exception/handle-exception';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    handleException(error);
  }, [error]);

  return (
    <html>
      <body className="font-sans">
        {/* This is the default Next.js error component but it doesn't allow omitting the statusCode property yet. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
